import React from 'react';
import { Transaction } from '../../../../types/rest/assetCatalogTypes';
import _ from 'lodash';
import i18n from '../../../../i18n';

const RedirectToLiveDetail = (props: { transaction: Transaction }) => {
  const redirectUrl = _.get(props.transaction, 'dsl.redirectUrl');
  const isRedirectEnabled = !_.isNil(redirectUrl) && !_.isEmpty(redirectUrl);
  const isFailOverEnabled = _.get(props.transaction, 'dsl.responseDsl.failoverEnabled');

  const getSslUsageMode = () => {
    const assetAssignments = props.transaction.assets;
    if (_.isNil(assetAssignments) || _.size(assetAssignments) === 0) {
      return i18n.t('common:sslConfig.notDefined');
    }

    const assignmentType = props.transaction.assets[0].assetUsageType;
    if (assignmentType === 'CLIENT_TRUSTSTORE_CERT') {
      return i18n.t('common:sslConfig.oneWay');
    } else if (assignmentType === 'CLIENT_KEYSTORE_TRUSTSTORE') {
      return i18n.t('common:sslConfig.twoWay');
    }
    return '';
  };

  const getSection = (sectionName: string, value: string) => {
    return (
      <div className={'mt-4'}>
        <strong className={'mr-4'}>{sectionName}:</strong>
        <span>{value}</span>
      </div>
    );
  };

  const getRedirectDetails = () => {
    return (
      <>
        {getSection(i18n.t('common:sslConfig.type'), i18n.t('transactions:redirectToLive.title'))}
        {getSection(i18n.t('transactions:redirectToLive.failOver.title'), isFailOverEnabled ? 'Enabled' : 'Disabled')}
        {getSection(i18n.t('common:sslConfig.title'), getSslUsageMode())}
      </>
    );
  };

  return <div>{isRedirectEnabled ? getRedirectDetails() : i18n.t('transactions:redirectToLive.notDefined')}</div>;
};

export default RedirectToLiveDetail;
